import { simpleDeepCopy } from 'shared/utils/utils';


// const conversions = [
//   { version: '1',
//     isSuitableVersion: isSuitableVersion(toVersion, version), // optional
//     isSuitableObject: isSuitableObject(object, version), // optional
//     rules: [
//       { isSuitable: isSuitable(object, isMigratingUp),
//         migrateUp: migrateUp(object), // from the previous version to this one
//         migrateDown: migrateDown(object), // from this version to the previous one
//       },
//       ...
//     ],
//   },
//   ...
// ];

export function migrateToTheLatest(objects, conversions) {
  const latestIndex = conversions.length - 1;
  return migrateByIndex(objects, conversions, latestIndex);
}

export function migrate(objects, conversions, toVersion = null) {
  const toIndex = toVersion === null // Migrate to the lowest
    ? -1
    : conversions.findIndex(({ version, isSuitableVersion }) =>
      version === toVersion || isSuitableVersion?.(toVersion, version)
    );
  return migrateByIndex(objects, conversions, toIndex);
}


function migrateByIndex(objects, conversions, toIndex) {
  let isAnyMigrated = false;

  objects = objects.map(object => {
    const fromIndex = conversions.findIndex(({ isSuitableObject, version }) =>
      version === object.version || isSuitableObject?.(object, version)
    );

    if (fromIndex === -1) {
      return object;
    }

    const { isMigrated, object: out } = migrateObject(object, conversions, fromIndex, toIndex);
    isAnyMigrated ||= isMigrated;
    return out;
  });

  return { objects, isAnyMigrated };
}

function migrateObject(object, conversions, fromIndex, toIndex) {
  // console.log('migrateObject: ', object, fromIndex, toIndex);

  if (fromIndex === toIndex) {
    return { object, isMigrated: false };
  }

  const isMigratingUp = toIndex > fromIndex;
  let currentIndex = isMigratingUp ? fromIndex + 1 : fromIndex;
  let converted = simpleDeepCopy(object);

  while (isMigratingUp ? currentIndex <= toIndex : currentIndex > toIndex) {
    const conversion = conversions[currentIndex];
    conversion.rules.forEach(rule => {
      if (rule.isSuitable(converted, isMigratingUp)) {
        const fn = isMigratingUp ? rule.migrateUp : rule.migrateDown;
        converted = fn?.(converted) ?? converted;
      }
    });

    const version = isMigratingUp
      ? conversion.version
      : !currentIndex ? null : conversions[currentIndex - 1].version;
    version === null
      ? delete converted.version
      : converted.version = version;

    currentIndex += isMigratingUp ? 1 : -1;
  }

  return { object: converted, isMigrated: true };
}
